import { applyOgImageModifications } from '../utils/build-og-image';
import { resolvePayload } from './resolve-payload';
import { resolveIsIndexable } from './utils/resolve-is-indexable';
import { sort } from './sort';
import { getLink } from './utils/get-link';
import { cleanBlackListedTags } from './utils/clean-black-listed-tags';
import { fillInPatternBlob } from '../patterns/fill-in-pattern-blob';
import adapter from '../item-types/static-page/adapter-static-page';
import { removeBlackListedTags } from './utils/remove-black-listed-tags';
export function resolveWithPatterns(payload, context, shouldRemoveBlackListTags) {
  if (shouldRemoveBlackListTags === void 0) {
    shouldRemoveBlackListTags = false;
  }

  context = context || {};
  var result = resolvePayload(payload);
  result.tags = resolveIsIndexable(result.tags, context);
  result.tags = result.tags.concat(getLink(context, adapter.IDs.NEXT, 'next')).concat(getLink(context, adapter.IDs.PREV, 'prev'));
  result = fillInPatternBlob(result, context);
  result.tags = applyOgImageModifications(result.tags);

  if (shouldRemoveBlackListTags) {
    result.tags = removeBlackListedTags(result.tags);
  } else {
    result.tags = cleanBlackListedTags(result.tags);
  }

  result.tags = sort(result.tags);
  return result;
}